import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  Button,
  IconButton,
  CircularProgress,
} from "@mui/material";
import { ReactComponent as CloseIcon } from "../../asserts/logo/close.svg";
import { ReactComponent as DangerIcon } from "../../asserts/logo/Danger.svg";

const BTN_SHADOW = "0px 1px 2px 0px #0000000A";

const PRIMARY_BTN_BG =
  "linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.25) 100%), linear-gradient(0deg, #005BF0, #005BF0)";

const PRIMARY_BTN_BG_HOVER =
  "linear-gradient(180deg, rgba(0, 0, 0, 0.08) 0%, rgba(0, 0, 0, 0.08) 100%), linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.25) 100%), linear-gradient(0deg, #005BF0, #005BF0)";

export default function DeleteProjectDialog({
  open,
  projectName,
  selectedCount = 1,
  deleting = false,
  onCancel,
  onConfirm,
}) {
  const isBulk = selectedCount > 1;
  const displayName = projectName || "this project";

  return (
    <Dialog
      open={open}
      onClose={deleting ? undefined : onCancel}
      maxWidth={false}
      PaperProps={{
        sx: {
          width: 600,
          maxWidth: 600,
          minHeight: 317,
          borderRadius: "4px",
          bgcolor: "#FFFFFF",
          boxShadow: "0px 10px 10px 0px #0000003D, 0px 0px 10px 0px #2122261F",
          m: 2,
          overflow: "visible",
        },
      }}
    >
      <IconButton
        onClick={onCancel}
        disabled={deleting}
        aria-label="Close"
        sx={{
          position: "absolute",
          right: 16,
          top: 16,
          p: 0.5,
          "& path": { fill: "#555555" },
        }}
      >
        <CloseIcon style={{ width: 20, height: 20, display: "block" }} />
      </IconButton>

      <DialogContent
        sx={{
          boxSizing: "border-box",
          p: "40px 64px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "16px",
          textAlign: "center",
          overflow: "visible",
        }}
      >
        <Box
          sx={{
            position: "relative",
            width: 64,
            height: 64,
            flexShrink: 0,
            "& path": { fill: "#FFAB00" },
          }}
        >
          <DangerIcon
            style={{
              position: "absolute",
              top: 12.8,
              left: 10.67,
              width: 42.55352020263672,
              height: 38.26918029785156,
              display: "block",
            }}
            aria-hidden
          />
        </Box>

        <Typography
          sx={{
            fontFamily: "Lato, sans-serif",
            fontWeight: 900,
            fontSize: 20,
            lineHeight: "27px",
            letterSpacing: 0,
            color: "#000000",
            width: "100%",
            maxWidth: 472,
          }}
        >
          {isBulk ? `Delete ${selectedCount} Projects?` : "Delete this Project?"}
        </Typography>

        <Typography
          sx={{
            fontFamily: "Lato, sans-serif",
            fontWeight: 400,
            fontSize: 14,
            lineHeight: "21px",
            letterSpacing: 0,
            color: "#555555",
            width: "100%",
            maxWidth: 472,
          }}
        >
          {isBulk
            ? `Are you sure you want to delete ${selectedCount} selected projects and their test history? These projects will be permanently removed.`
            : `Are you sure you want to delete this project ? "${displayName}" and its test history will be removed. This project will be permanently removed.`}
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexWrap: "nowrap",
            justifyContent: "center",
            alignItems: "center",
            gap: "16px",
            mt: 0.5,
          }}
        >
          <Button
            variant="outlined"
            onClick={onCancel}
            disabled={deleting}
            sx={{
              textTransform: "none",
              fontFamily: "Lato, sans-serif",
              fontWeight: 700,
              fontSize: 15,
              lineHeight: "24px",
              letterSpacing: 0,
              width: 77,
              minWidth: 77,
              height: 40,
              minHeight: 40,
              py: "8px",
              px: "16px",
              gap: "4px",
              bgcolor: "#FFFFFF",
              color: "#005BF0",
              borderRadius: "4px",
              border: "1px solid #005BF0",
              boxShadow: BTN_SHADOW,
              "&:hover": {
                bgcolor: "#F0F6FF",
                border: "1px solid #005BF0",
                boxShadow: BTN_SHADOW,
              },
            }}
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            onClick={onConfirm}
            disabled={deleting}
            disableElevation
            sx={{
              textTransform: "none",
              fontFamily: "Lato, sans-serif",
              fontWeight: 700,
              fontSize: 15,
              lineHeight: "24px",
              letterSpacing: 0,
              minWidth: 140,
              width: "auto",
              height: 40,
              minHeight: 40,
              py: "8px",
              px: "16px",
              gap: "4px",
              whiteSpace: "nowrap",
              flexShrink: 0,
              color: "#FFFFFF",
              borderRadius: "4px",
              border: "1px solid transparent",
              boxShadow: BTN_SHADOW,
              backgroundColor: "transparent",
              backgroundImage: PRIMARY_BTN_BG,
              "&:hover": {
                backgroundColor: "transparent",
                backgroundImage: PRIMARY_BTN_BG_HOVER,
                boxShadow: BTN_SHADOW,
              },
            }}
          >
            {deleting ? <CircularProgress size={22} sx={{ color: "#FFFFFF" }} /> : (isBulk ? "Delete Projects" : "Delete Project")}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
